import { UserRemoteAccessSettingsDto } from '@sr/dto';
import { FormTools } from 'utils/form-tools';
import { FormikErrors } from 'formik';
import { NotificationsConfig } from 'shared/ui/snack';

export type FormValues = {
  id: number | '';
  remoteAccess: boolean;
  remoteAccessIP: string;
};

export const notificationsConfig: NotificationsConfig = {
  itemTitleForm1: 'настройки удаленного доступа',
  itemTitleForm2: 'настройки удаленного доступа',
  gender: 'plural',
};

export const formTools: FormTools<UserRemoteAccessSettingsDto, UserRemoteAccessSettingsDto, UserRemoteAccessSettingsDto, FormValues> = {
  toCreateDto: (formData): UserRemoteAccessSettingsDto => ({
    id: Number(formData.id),
    remoteAccess: formData.remoteAccess,
    remoteAccessIP: formData.remoteAccessIP,
  }),

  toUpdateDto: (userId, formData): UserRemoteAccessSettingsDto => ({
    id: userId,
    remoteAccess: formData.remoteAccess,
    remoteAccessIP: formData.remoteAccessIP,
  }),

  fromDto: (dto): FormValues => {
    return {
      id: dto.id,
      remoteAccess: dto.remoteAccess,
      remoteAccessIP: dto.remoteAccessIP,
    };
  },

  emptyValues: () => ({
    id: '',
    remoteAccess: false,
    remoteAccessIP: '',
  }),

  validate: (values: FormValues): FormikErrors<FormValues> => {
    const validationResult: FormikErrors<FormValues> = {};
    const ipRegexp = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/;
    if (ipRegexp.test(values.remoteAccessIP) === false) validationResult.remoteAccessIP = 'Неверный формат IP-адреса';
    return validationResult;
  },
};
